import CalendarRepository from '@/api/calendarRepository';
import AuthRepository from './authRepository';
import CommentRepository from './commentRepository';
import DomainRepository from './domainRepository';
import NewsletterRepository from './newsletterRepository';
import ProjectRepository from './projectRepository';
import ThoughtRepository from './thoughtRepository';
import TopicRepository from './topicRepository';
import UserRepository from './userRepository';
import FeedbackRepository from './feedbackRepository';
import AttributeRepository from './attributeRepository';
import TimelineRepository from './timelineRepository';

const repositories: any = {
  user: UserRepository,
  auth: AuthRepository,
  newsletter: NewsletterRepository,
  project: ProjectRepository,
  topic: TopicRepository,
  thought: ThoughtRepository,
  calendar: CalendarRepository,
  comment: CommentRepository,
  domain: DomainRepository,
  feedback: FeedbackRepository,
  attribute: AttributeRepository,
  timeline: TimelineRepository,
};

export const RepositoryFactory = {
  get: (name: string) => repositories[name],
};
